import React from 'react'
import Navbar from '../inc/Navbar';
import { Link } from "react-router-dom";

import ScrollToTop from "react-scroll-to-top";
import Labtest from './Labtest';


function Labpage() {
  return (
    <div>
          <Navbar />


      <br />
      <br />
      <ScrollToTop smooth top="100" color="light" />

      <br />
      <br />

      <div className='drlalpathlabkrishnagar'>
        <div className="album py-1 ">

          <div className="container mt-3">

            <div className="row">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li style={{ color: "grey" }} className="breadcrumb-item"><Link style={{ color: "grey" }} to="/" >  Home</Link></li>

                  <li className="breadcrumb-item active" aria-current="page">Find a Test</li>

                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <Labtest/>
    </div>
  )
}

export default Labpage